import React, { useState } from "react";
import SideMenuHOD from "./SideMenuHOD";
import Header from "./Header";
import mainPic from "../assets/images/Rectangle 626.png";
import imgDocs from "../assets/images/Group 1000003697.png";
import imgChart from "../assets/images/Frame 71.png";

export default function ReportLayout({ title, onDownload, children }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden">
      <SideMenuHOD
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
      />

      <div className="flex flex-col flex-1 overflow-y-auto bg-gray-50">
        <Header onMenuToggle={() => setIsSidebarOpen((v) => !v)} />

        <main className="p-4 md:p-8">
          {/* Banner */}
          <div className="mb-8">
            <img
              src={mainPic}
              alt="Banner"
              className="w-full h-40 md:h-56 object-cover rounded-lg shadow"
            />
          </div>

          <div className="flex flex-col md:flex-row items-start md:items-center gap-8">
            {/* Form pane */}
            {/* <div className="bg-white border border-primary-200 rounded-lg shadow p-6 w-full md:w-1/3"> */}
            <div className="bg-white  rounded-lg shadow shadow-primary-200 p-6 w-full md:w-1/3 min-h-[560px] md:mr-16">
              <h2 className="text-xl font-semibold mb-6">{title}</h2>
              <div className="space-y-4">
                {children}
                <button
                  onClick={onDownload}
                  className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 rounded transition"
                >
                  Download Report
                </button>
              </div>
            </div>

            {/* Illustration + Text + Chart */}
            <div className="flex flex-col md:flex-row items-start justify-start gap-4 md:gap-6">
              <img
                src={imgDocs}
                alt="Documents Illustration"
                className="w-20 h-20 md:w-28 md:h-28"
              />
              <div className="flex flex-col max-w-md">
                <h3 className="text-2xl font-bold mb-2">
                  Filter, Find, and Download in Seconds
                </h3>
                <div className="flex items-start gap-5 m-2">
                  <p className="text-gray-600">
                    Use smart filters and tags to download any report instantly
                    — no matter how old or detailed.
                  </p>
                  <img
                    src={imgChart}
                    alt="Chart Icon"
                    className="w-16 h-16 md:w-16 md:h-16"
                  />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
